import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('marketingSmsManagementDetailsStore')
@observer
class MarketingSmsManagementDetails extends Component {
  render() {
    const { marketingSmsManagementDetailsStore, location } = this.props
    const { isFetching } = marketingSmsManagementDetailsStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default MarketingSmsManagementDetails;
